var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup35791(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35791",
    transform: "translate(-677 -1498)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 346",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(677 1498)",
    style: {
      opacity: 0.2,
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 34627"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41393",
    d: "M-733.2-4017.7v1.241a.425.425 0 0 0 .487.473c.148 0 .328-.04.439.026.146.089.329.264.331.4s-.183.3-.32.413c-.071.057-.215.03-.327.03h-5.592c-.111 0-.257.024-.325-.034-.136-.115-.307-.276-.314-.425-.006-.126.189-.271.314-.39.043-.039.143-.021.217-.022.682-.022.744-.083.744-.748 0-.284 0-.568-.009-.852a.574.574 0 0 0-.045-.118h-.749c-.286 0-.492-.128-.491-.436s.208-.431.493-.433h10.102c.583 0 .667-.083.668-.665v-9.854c0-.6-.082-.679-.692-.679H-742.5c-.58 0-.674.092-.674.662v3.815a.773.773 0 0 1-.043.4.6.6 0 0 1-.386.272.6.6 0 0 1-.394-.258.72.72 0 0 1-.054-.394v-3.853a1.342 1.342 0 0 1 1.543-1.514h14.277c1.061 0 1.54.484 1.54 1.547v9.89a1.324 1.324 0 0 1-1.5 1.508h-4.548zm-.884 1.7v-1.671h-2.611v1.671z",
    transform: "translate(1428.182 5535.876)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41394",
    d: "M-746.644-4016.233v-2.7a1.2 1.2 0 0 1 1.308-1.324q1.508-.02 3.015 0a1.193 1.193 0 0 1 1.318 1.311q.016 2.72 0 5.44a1.2 1.2 0 0 1-1.341 1.326c-.993.007-1.986.009-2.98 0a1.214 1.214 0 0 1-1.323-1.347l.003-2.706zm.814.009v2.667c0 .451.106.556.546.557h2.944c.411 0 .538-.124.539-.538v-5.368c0-.416-.127-.541-.536-.542q-1.471-.005-2.944 0c-.438 0-.546.111-.548.558-.003.89-.001 1.777-.001 2.667z",
    transform: "translate(1429.161 5532.946)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41395",
    d: "M-731.438-4015.549h-4.401a.384.384 0 0 1-.408-.385c-.01-.266.154-.4.406-.423a1.9 1.9 0 0 1 .208-.006h8.524c.284 0 .513.079.531.41.014.262-.174.405-.529.406q-2.166.002-4.331-.002z",
    transform: "translate(1426.443 5531.116)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41396",
    d: "M-731.406-4014.412c.359.039.5.172.492.417a.353.353 0 0 1-.4.376c-.245-.008-.412-.163-.367-.4.033-.156.201-.292.275-.393z",
    transform: "translate(1424.166 5530.464)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41397",
    d: "M-742.428-4009.651c-.1-.152-.265-.3-.287-.459-.032-.233.144-.379.39-.375s.411.165.369.394c-.03.162-.2.3-.3.445z",
    transform: "translate(1428.242 5529.243)",
    style: {
      fill: "#5f7d95"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup35791);
export default __webpack_public_path__ + "static/media/Group35791.9d1356b65e90575b2f4ee537b8373f9a.svg";
export { ForwardRef as ReactComponent };